module.exports = __webpack_public_path__ + "img/spinner-third.f22ea9ff.svg";